// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  contentStack: {
    padding: `${theme.other.spacing._32}px ${theme.other.spacing._16}px ${theme.other.spacing._16}px`,
  },

  iconContainer: {
    marginBottom: theme.other.spacing._4,
  },

  title: {
    fontWeight: 700,
    letterSpacing: '-0.4px',
  },

  description: {
    maxWidth: 342,
  },

  commissionerCard: {
    width: '100%',
    maxWidth: 342,
    height: 72,
    backgroundColor: theme.white,
    border: `1px dashed ${theme.colors.gray2[1]}`,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: `10px ${theme.other.spacing._16}px`,
  },

  commissionerLabel: {
    position: 'absolute',
    top: -14, // Specific positioning for label overlay
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: theme.white,
    padding: `0 ${theme.other.spacing._4}px`,
  },

  commissionerName: {
    letterSpacing: '-0.32px',
  },

  buttonContainer: {
    width: '100%',
    maxWidth: 342,
  },
}));

export default useStyles;
